<template>
  <DialogTemplate>
    <div
      class="pt-2 pl-2"
      style="max-width: 620px"
    >
      <div class="text-large weight_700 clr-primary">
        {{ $t('tips.study.graph_switcher.show_height_of_hand_combo') }}
      </div>
      <div class="f-align-center pb-1 weight_600 mt-4">
        <div class="sgs_icon icon_range_height"></div>
        {{ $t('tips.study.graph_switcher.range_height') }}
      </div>
      <div
        class="ml-8 clr-grey text-medium"
        v-html="$t('tips.study.graph_switcher.range_height_text')"
      ></div>

      <div class="f-align-center pb-1 weight_600 mt-4">
        <div class="sgs_icon icon_full_height"></div>
        {{ $t('tips.study.graph_switcher.full_height') }}
      </div>
      <div
        class="ml-8 clr-grey text-medium"
        v-html="$t('tips.study.graph_switcher.full_height_text')"
      ></div>

      <!-- <span class="text-small glr-grey"></span> -->

      <div class="f-align-center pb-1 weight_600 mt-4">
        <div class="sgs_icon icon_normalized"></div>
        {{ $t('tips.study.graph_switcher.normalized') }}
      </div>
      <div
        class="ml-8 clr-grey text-medium"
        v-html="$t('tips.study.graph_switcher.normalized_text')"
      ></div>

      <div class="text-large weight_600 mt-6 clr-primary">
        {{ $t('tips.study.graph_switcher.how_to_view_combo') }}
      </div>
      <div class="f-align-center pb-1 weight_600 mt-4">
        <!-- <v-icon class="mr-2 rotated_90">mdi-format-line-weight</v-icon>  -->
        <div class="sgs_icon icon_vertical"></div>

        {{ $t('tips.study.graph_switcher.vertical') }}
      </div>
      <div
        class="ml-8 clr-grey text-medium"
        v-html="$t('tips.study.graph_switcher.vertical_text')"
      ></div>

      <div class="f-align-center pb-1 weight_600 mt-4">
        <v-icon class="mr-2">mdi-poll</v-icon>
        {{ $t('tips.study.graph_switcher.horizontal') }}
      </div>
      <div
        class="ml-8 clr-grey text-medium"
        v-html="$t('tips.study.graph_switcher.horizontal_text')"
      ></div>

      <img
        class="w-100 ml-8 mt-4"
        :src="getImage('horizontal_vertical_example')"
        style="border-radius: 8px; max-width: 320px"
      />
      <div
        class="ml-8 clr-grey text-medium"
        v-html="$t('tips.study.graph_switcher.example')"
      ></div>
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'StudyGraphSwitcherHelpDialog',

  components: {
    DialogTemplate,
  },
  data() {
    return {}
  },
  methods: {
    getImage(img) {
      return new URL(`/src/assets/img/${img}.webp`, import.meta.url).href
    },
    close() {
      this.$store.dispatch('router_reset_dialogs')
    },
  },
}
</script>

<style lang="scss" scoped>
.sgs {
  display: flex;
  height: 24px;
  width: 24px;
  overflow: hidden;
  border-radius: 4px;
  &_icon {
    height: 16px;
    width: 16px;
    margin: 0 12px 0 3px;
    border-radius: 2px;
    border: solid currentColor 1px;
    overflow: hidden;
    position: relative;
    &:before {
      content: '';
      background: currentColor;
      width: 100%;
      position: absolute;
    }
  }
}

.icon_vertical {
  &:before {
    height: 200%;
    width: 200% !important;
    left: -150%;
    bottom: 0;
  }
}
.icon_range_height {
  &:before {
    height: 50%;
    bottom: 0;
  }
}
.icon_full_height {
  &:before {
    height: 100%;
  }
}
.icon_normalized {
  &:before {
    height: 200%;
    width: 200% !important;
    left: -150%;
    transform: rotate(45deg);
  }
}
</style>
